/**
 * Created by Tiger on 27/02/2022.
 */
import React, { useEffect, useLayoutEffect, useMemo, useState } from 'react'
import { Form, Modal, Typography } from 'antd'
import {
  EncryptType,
  getCollectionConfig,
  NetworkType,
} from '../../common/util'
import { EditOutlined } from '@ant-design/icons'
import ALiConfig from './ali-config'
import {
  BLE_INTERVAL_OPTIONS,
  COLLECT_INTERVAL_OPTIONS,
  ENCRYPT_TYPE_OPTION,
  NETWORK_TYPE_OPTIONS,
  REPORT_INTERVAL_OPTIONS,
} from './define'
import CustomMqttConfig from './custom-mqtt-config'
import actions from '../../redux/action'
import { connect } from 'react-redux'
import Styles from './css/NewConfig.module.scss'
import i18n from 'i18next'
import { SelectItem } from '../../components/select-item'
import { InputItem } from '../../components/inputItem'
import CustomConfigField from './custom-config-field'
import { assertBoolean } from '@babel/core/lib/config/validation/option-assertions'

const MaybeEncrypt = ['CGP1', 'CGF1']

const formatConfig = (config) => {
  let newConfig = []
  Reflect.ownKeys(config).forEach((key) => {
    if (newConfig.length > 0) newConfig.push(<br />)
    newConfig.push(`${key}=${Reflect.get(config, key)}`)
  })
  return newConfig
}

function NewConfig(props) {
  const [title, setTitle] = useState(i18n.t('add_config'))
  const [showReportInterval, setShowReportInterval] = useState(false)
  const [showCollectInterval, setShowCollectInterval] = useState(false)
  const [deviceType, setDeviceType] = useState(null)
  const renderEncryptType = useMemo(() => {
    return MaybeEncrypt.includes(deviceType)
  }, [deviceType])
  useEffect(() => {
    props.onRefreshProducts(props.language)
  }, [])

  useLayoutEffect(() => {
    const { config } = props
    console.log('config:', config)
    if (config) {
      setTitle(i18n.t('change_config'))
      const {
        name,
        product,
        networkConfig,
        reportConfig,
        encryptConfig,
        customKv,
      } = config
      setName(name)
      setDeviceType(product.code)
      setEncryptType(encryptConfig?.type)
      setNetworkType(networkConfig.type)
      setReportConfig(reportConfig)
      setEncrypt(encryptConfig?.secretKey)
      setNetworkConfig(networkConfig)
      setIsBleProduct(!Boolean(product?.noBleSetting))
      setCustomKv(customKv)
    }
  }, [props.config, props.products])
  const [isBleProduct, setIsBleProduct] = useState(false)
  const [networkType, setNetworkType] = useState(null)
  const [name, setName] = useState('')
  const [networkConfig, setNetworkConfig] = useState({})
  const [aliConfigVisible, setAliConfigVisible] = useState(false)
  const [mqttConfigVisible, setMqttConfigVisible] = useState(false)
  const [encryptType, setEncryptType] = useState(EncryptType.NoEncrypt)
  const [encrypt, setEncrypt] = useState(undefined)
  const [reportConfig, setReportConfig] = useState({
    collectInterval: 15,
    bleAdvInterval: 4000,
    reportInterval: 60,
  })
  let netConfig = ''
  if (networkType === NetworkType.AliBabaIoT) {
    netConfig = networkConfig.aliConfig
  } else if (networkType === NetworkType.CustomMQTT) {
    netConfig = networkConfig.mqttConfig
  }
  if (netConfig && typeof netConfig === 'object') {
    netConfig = formatConfig(netConfig)
  }
  const [customKv, setCustomKv] = useState(undefined)
  const [customConfigVisible, setCustomConfigVisible] = useState(false)

  useEffect(() => {
    if (!props.config) {
      setReportConfig({
        ...reportConfig,
        ...getCollectionConfig(deviceType),
      })
    }
    console.log(deviceType, 'deviceType')
    if (
      deviceType === 'CGSPR1' ||
      deviceType === 'CGS1' ||
      deviceType === 'CGCT1'
    ) {
      setShowCollectInterval(false)
    } else {
      setShowCollectInterval(true)
    }

    if (deviceType === 'CGS1' || deviceType === 'CGCT1') {
      setShowReportInterval(false)
    } else {
      setShowReportInterval(true)
    }
  }, [deviceType])

  return (
    <>
      <Modal
        width={document.body.clientWidth / 3}
        maskClosable={false}
        title={<span>{title}</span>}
        okText={i18n.t('consent')}
        cancelText={i18n.t('cancel')}
        visible={props.visible}
        onCancel={props.onCancel}
        onOk={() => {
          let newNetWorkConfig
          if (networkType === NetworkType.AliBabaIoT) {
            newNetWorkConfig = {
              type: NetworkType.AliBabaIoT,
              aliConfig: networkConfig.aliConfig,
            }
          } else {
            newNetWorkConfig = {
              type: NetworkType.CustomMQTT,
              mqttConfig: networkConfig.mqttConfig,
            }
          }
          const config = {
            name,
            product: { code: deviceType },
            networkConfig: newNetWorkConfig,
            reportConfig,
            encryptConfig: {
              type: encryptType,
              secretKey: encrypt,
            },
            customKv,
          }
          console.log('config:', config)
          if (props.config) {
            config.id = props.config.id
            props.onUpdateConfig(config)
          } else {
            props.onNewConfig(config)
          }
          props.onOk()
        }}
        closable={true}
      >
        <Form>
          <InputItem
            key={'config-name'}
            label={i18n.t('config')}
            style={{ marginTop: 0 }}
            value={name}
            onChange={(event) => {
              setName(event?.target?.value)
            }}
          />
          <SelectItem
            key={'device-type'}
            label={i18n.t('device_type')}
            placeholder={i18n.t('please_select')}
            options={props.products}
            value={{ value: deviceType }}
            onSelect={(event) => {
              const product = props.products.find(
                (product) => product.value === event.value
              )
              console.log('product:', product)
              setIsBleProduct(product.ble === 'true')
              setDeviceType(event?.value)
            }}
          />
          <SelectItem
            key={'net-type'}
            label={i18n.t('net_type')}
            value={{ value: networkType }}
            placeholder={i18n.t('please_select')}
            options={NETWORK_TYPE_OPTIONS()}
            onSelect={(event) => {
              setNetworkType(event?.value)
            }}
          />

          {networkType && (
            <Typography.Text
              key={'network-type-entry'}
              className={Styles.marginTop}
            >
              {networkType === NetworkType.AliBabaIoT
                ? i18n.t('edit_ali_iot_info_tip')
                : i18n.t('edit_mqtt_info_tip')}
            </Typography.Text>
          )}
          {networkType && (
            <Typography.Paragraph
              className={Styles.networkConfig}
              editable={{ icon: <EditOutlined /> }}
              onClick={() =>
                networkType === NetworkType.AliBabaIoT
                  ? setAliConfigVisible(true)
                  : setMqttConfigVisible(true)
              }
            >
              {netConfig}
            </Typography.Paragraph>
          )}
          {aliConfigVisible && (
            <ALiConfig
              config={networkConfig.aliConfig}
              visible={aliConfigVisible}
              onOk={({ aliConfig }) => {
                console.log('aliConfig:', aliConfig)
                setNetworkConfig({
                  aliConfig,
                  mqttConfig: i18n.t('edit_mqtt_info_tip'),
                })
                setAliConfigVisible(false)
              }}
              onCancel={() => setAliConfigVisible(false)}
            />
          )}
          {mqttConfigVisible && (
            <CustomMqttConfig
              config={networkConfig.mqttConfig}
              visible={mqttConfigVisible}
              onOk={({ mqttConfig }) => {
                console.log('aliConfig:', mqttConfig)
                setNetworkConfig({
                  mqttConfig,
                  aliConfig: i18n.t('edit_ali_iot_info_tip'),
                })
                setMqttConfigVisible(false)
              }}
              onCancel={() => setMqttConfigVisible(false)}
            />
          )}
          {renderEncryptType && (
            <>
              <SelectItem
                label={i18n.t('encrypt_type')}
                value={{ value: encryptType }}
                placeholder={i18n.t('please_select')}
                onSelect={({ value }) => {
                  setEncryptType(value)
                }}
                options={ENCRYPT_TYPE_OPTION()}
              />
              {encryptType === EncryptType.FixedEncrypt && (
                <InputItem
                  label={i18n.t('secret_key')}
                  defaultValue={encrypt}
                  onChange={(event) => setEncrypt(event?.target?.value)}
                  value={encrypt}
                />
              )}
            </>
          )}

          {showReportInterval && (
            <SelectItem
              key={'report-interval'}
              label={i18n.t('report_interval')}
              value={{ value: reportConfig?.reportInterval ?? null }}
              onSelect={({ value }) => {
                setReportConfig({
                  ...reportConfig,
                  reportInterval: value,
                })
              }}
              options={REPORT_INTERVAL_OPTIONS(deviceType)}
              placeholder={i18n.t('please_select')}
            />
          )}
          {showCollectInterval && (
            <SelectItem
              key={'collect-interval'}
              label={i18n.t('collect_interval')}
              value={{ value: reportConfig?.collectInterval ?? null }}
              onSelect={({ value }) => {
                setReportConfig({
                  ...reportConfig,
                  collectInterval: value,
                })
              }}
              options={COLLECT_INTERVAL_OPTIONS()}
              placeholder={i18n.t('please_select')}
            />
          )}
          {isBleProduct && deviceType !== 'CGCT1' && (
            <>
              <SelectItem
                key={'ble-interval'}
                label={i18n.t('ble_interval')}
                value={{ value: reportConfig?.bleAdvInterval ?? null }}
                onSelect={({ value }) => {
                  setReportConfig({
                    ...reportConfig,
                    bleAdvInterval: value,
                  })
                }}
                options={BLE_INTERVAL_OPTIONS()}
                placeholder={i18n.t('please_select')}
              />
              <InputItem
                key={'ble-name'}
                label={i18n.t('ble_name')}
                defaultValue={reportConfig?.bleAdvName ?? null}
                onChange={(event) => {
                  setReportConfig({
                    ...reportConfig,
                    bleAdvName: event?.target?.value,
                  })
                }}
                value={reportConfig?.bleAdvName ?? ''}
              />
            </>
          )}
        </Form>
        <Typography.Text key={'custom-config'} className={Styles.marginTop}>
          {i18n.t('custom_config')}
        </Typography.Text>
        <Typography.Paragraph
          key={'custom-config-detail'}
          className={Styles.networkConfig}
          editable={{ icon: <EditOutlined /> }}
          onClick={() => {
            setCustomConfigVisible(true)
          }}
        >
          {customKv ? formatConfig(customKv) : ''}
        </Typography.Paragraph>
        {customConfigVisible && (
          <CustomConfigField
            key={'custom-config-component'}
            visible={customConfigVisible}
            fields={customKv}
            onCancel={() => {
              setCustomConfigVisible(false)
            }}
            onOk={(kv) => {
              setCustomKv(kv)
              setCustomConfigVisible(false)
            }}
          />
        )}
      </Modal>
    </>
  )
}

const mapState2Props = (state) => {
  console.log('state:', state)
  return {
    language: state.language.language,
    products: state.config.products,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onNewConfig: (config) => dispatch(actions.onNewConfig(config)),
    onUpdateConfig: (config) => dispatch(actions.onUpdateConfig(config)),
    onRefreshProducts: (language) =>
      dispatch(actions.onRefreshProducts(language)),
  }
}

export default connect(mapState2Props, mapDispatchToProps)(NewConfig)
